// Runtime API URL detection - works on any domain without rebuild
const getBaseUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && envUrl !== 'undefined' && !envUrl.includes('undefined')) {
    return envUrl;
  }
  return window.location.origin;
};

export const API_BASE = getBaseUrl();
export const API_URL = getBaseUrl() + '/api';
